import React, { useState, useMemo } from "react";
import { useDispatch } from "react-redux";

import Actions from "../../store/actions/vehicleActions";
import VehicleFilter from "../../helpers/vehicle/filter";

function Filter() {
	const dispatch = useDispatch();

	const [vin, setVin] = useState(``);
	const [device, setDevice] = useState(``);

	const isDisabled = useMemo(() => {
		return !VehicleFilter.isEnabled(vin, device);
	}, [device, vin]);

	function onEnterPress(event) {
		event.key === `Enter` && searchVehicle();
	}

	function searchVehicle() {
		if (vin && VehicleFilter.vinEnabled(vin)) {
			dispatch(Actions.searchByVin(vin));
		}
		else if (device && VehicleFilter.deviceEnabled(device)) {
			dispatch(Actions.searchByDevice(device));
		}
	}

	return (
		<>
			<div className="row">
				<div className="col-xs-3">
					<label htmlFor="vin" className="control-label">
						VIN:
					</label>
					<input
						className="form-control"
						type="text"
						name="vin"
						onChange={e => {
							setVin(e.target.value);
						}}
						onKeyPress={onEnterPress}
						value={vin}
					/>
				</div>
				<div className="col-xs-3">
					<label htmlFor="device" className="control-label">
						Multimedia Device ID:
					</label>
					<input
						className="form-control"
						type="text"
						name="device"
						onChange={e => {
							setDevice(e.target.value);
						}}
						onKeyPress={onEnterPress}
						value={device}
					/>
				</div>
				<div className="col-xs-3 col-xs-push-3">
					<button
						className="pull-right btn btn-primary margin-top-12"
						onClick={searchVehicle}
						disabled={isDisabled}
					>
						<span className="glyphicon glyphicon-search" aria-hidden="true" />
						{` `}
						Filter
					</button>
				</div>
			</div>
		</>
	);
}

export default Filter;
